import React from 'react'
import ProductCard  from './ProductCard'
import { Link } from 'react-router-dom'

function ProductSlider({products,howManyProductShowCss}) {

  return (
    <section id="product-slider" className="mt-2">
      <div className="flex overflow-x-auto slider-container">
        {products.map((product, index) => {
            
            return <ProductCard key={product.id} product={product} productCss="m-2 px-2" showProductCss={howManyProductShowCss} />
        })}
        <div className="flex justify-center items-center m-0 px-6 all-product-btn">
        <Link to={`/products`}>
        <button className="hover:shadow-lg px-4 p-3 border text-[12px] text-primary capitalize" style={{letterSpacing:'1px'}}> View all products</button>
        </Link>
        </div>
      </div>
    </section>
  )
}

export default ProductSlider